import Button from '../Button/Button'
import CSS from './styles.module.css'

// Animate on Scroll
import AOS from 'aos'
import 'aos/dist/aos.css'

// Icons
import FbIcon from '../../assets/images/facebookIcon.png'
import TwIcon from '../../assets/images/twitterIcon.png'
import InIcon from '../../assets/images/InstagramIcon.png'
import LiIcon from '../../assets/images/linkedinIcon.png'
import YtIcon from '../../assets/images/youtubeIcon.png'
import HeartIcon from '../../assets/images/heart-svgrepo-com.svg'
import { useEffect } from 'react'

const Footer = () => {
  useEffect(() => {
    AOS.init({ duration: 500, delay: 0 })
  }, [])

  return (
    <div className={CSS.Footer} data-aos="fade-up">
      <div className={CSS.TopFooter}>
        <div className={CSS.ParentContainer}>
          <div className={CSS.Container}>
            <div className={CSS.Partition} data-aos="fade-up">
              <div className={CSS.Heading}>Company</div>
              <div className={CSS.Links}>
                <a href="https://recooty.com/about">About Recooty</a>
                <a href="https://recooty.com/careers">Join our Team</a>
              </div>
            </div>
            <div className={CSS.Partition} data-aos="fade-up">
              <div className={CSS.Heading}>Compare</div>
              <div className={CSS.Links}>
                <a href="https://recooty.com/best-freshteam-alternative">
                  Freshteam Alternative
                </a>
                <a href="https://recooty.com/best-zoho-recruit-alternative">
                  Zoho Recruit Alternative
                </a>
                <a href="https://recooty.com/google-hire-alternative">
                  Google Hire Alternative
                </a>
                <a href="https://recooty.com/smartrecruiters-alternative">
                  SmartRecruiters Alternative
                </a>
              </div>
            </div>
          </div>
          <div className={CSS.Container}>
            <div className={CSS.Partition} data-aos="fade-up">
              <div className={CSS.Heading}>Product</div>
              <div className={CSS.Links}>
                <a href="https://recooty.com/applicant-tracking-system">
                  Applicant Tracking System
                </a>
                <a href="https://recooty.com/company-career-page">
                  Company Career Page
                </a>
                <a href="https://recooty.com/free-job-posting">
                  Free Job Posting
                </a>
                <a href="https://recooty.com/partners">Partner Job Boards</a>
                <a href="https://recooty.com/pricing">Pricing</a>
              </div>
            </div>
          </div>
          <div className={CSS.Container}>
            <div className={CSS.Partition} data-aos="fade-up">
              <div className={CSS.Heading}>Resources</div>
              <div className={CSS.Links}>
                <a href="https://recooty.com/blog/">HR Blog</a>
                <a href="https://recooty.com/blog/job-descriptions/">
                  Free Job Descriptions
                </a>
                <a href="https://recooty.com/hr-tools">Useful HR Tools</a>
              </div>
            </div>
            <div className={CSS.Partition} data-aos="fade-up">
              <div className={CSS.Heading}>Support</div>
              <div className={CSS.Links}>
                <a href="https://recooty.com/blog/user-guide/">Documentation</a>
                <a href="https://dash.recooty.com/settings/api">
                  API Integration
                </a>
                <a href="https://recooty.com/gdpr">GDPR</a>
                <a href="https://recooty.com/iso">ISO27001</a>
              </div>
            </div>
          </div>
          <div className={CSS.Container}>
            <div className={CSS.Partition} data-aos="fade-up">
              <div className={CSS.Heading}>Follow Us</div>
              <div className={CSS.Social}>
                <a href="https://www.facebook.com/RecootyApp/">
                  <Button
                    variant="ContrastBtnIcon"
                    icon={
                      <img
                        src={FbIcon}
                        style={{ height: '24px', width: 'auto' }}
                        alt="Facebook"
                      />
                    }
                  />
                </a>
                <a href="https://twitter.com/Recooty">
                  <Button
                    variant="ContrastBtnIcon"
                    icon={<img src={TwIcon} alt="twitter" />}
                  />
                </a>
                <a href="https://www.linkedin.com/company/recooty/">
                  <Button
                    variant="ContrastBtnIcon"
                    icon={
                      <img
                        src={LiIcon}
                        style={{ height: '20px', width: 'auto' }}
                        alt="linkedin"
                      />
                    }
                  />
                </a>
                <a href="https://www.youtube.com/c/Recooty">
                  <Button
                    variant="ContrastBtnIcon"
                    icon={<img src={YtIcon} alt="youtube" />}
                  />
                </a>
                <a href="https://www.instagram.com/recooty/">
                  <Button
                    variant="ContrastBtnIcon"
                    icon={
                      <img
                        src={InIcon}
                        style={{ height: '22px', width: 'auto' }}
                        alt="instagram"
                      />
                    }
                  />
                </a>
              </div>
            </div>
            <div className={CSS.Partition} data-aos="fade-up">
              <div className={CSS.Heading}>Recooty Inc.</div>
              <div className={CSS.Address}>
                <div>
                  2810 N Church St PMB 71936,
                  <br />
                  Wilmington, DE, 19802-4447, US
                </div>
                <div>
                  Support Email: <br />
                  <a href="mailto:support@recooty.com">support@recooty.com</a>
                </div>
                <a href="https://recooty.com/demo">
                  <Button>Schedule a Demo Call</Button>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className={CSS.Certifications} data-aos="fade-up">
          <div className={CSS.Left}>
            <a href="https://recooty.com/iso">
              <img
                src="https://recooty.com/images/iso-logo.png"
                alt="ISO27001 Certification"
              />
            </a>
            <a href="https://recooty.com/gdpr">
              <img
                src="https://recooty.com/images/gdpr-logo.png"
                alt="GDPR Compliant"
              />
            </a>
          </div>
          <div className={CSS.Right}>
            <img
              src="https://recooty.com/images/badges/g2-high-performer-23.png"
              alt="G2 High Performer Award 2023"
            />
            <img
              src="https://recooty.com/images/badges/g2-most-recommended-23.png"
              alt="G2 Most Recommended Award 2023"
            />
            <img
              src="https://recooty.com/images/badges/capterra-shortlist-23.png"
              alt="Capterra Shortlist 2023"
            />
            <img
              src="https://recooty.com/images/badges/getapp-leaders-23.png"
              alt="Get App Leaders Award 2023"
            />
            <img
              src="https://recooty.com/images/badges/software-advice-frontrunners-23.png"
              alt="Software Advice Frontrunners Award 2023"
            />
          </div>
        </div>
        <div className={CSS.BottomFooter}>
          <div className={CSS.Left}>
            © 2023, made with <img src={HeartIcon} alt="TeamRecooty" /> by #TeamRecooty
          </div>
          <div className={CSS.Right}>
            <a href="https://status.recooty.com/">Status</a>
            <a href="https://recooty.com/terms">Terms & Conditions</a>
            <a href="https://recooty.com/privacy-policy">Privacy Policy</a>
            <a href="https://recooty.com/?contact=true">Contact</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
